"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiGradCap16 = {
    paths: [
        {
            path: 'M1,3 C1.55228475,3 2,3.44771525 2,4 L2,8 C2,8.55228475 1.55228475,9 1,9 C0.44771525,9 6.76353751e-17,8.55228475 0,8 L0,4 C-6.76353751e-17,3.44771525 0.44771525,3 1,3 Z M14.9991283,0 C15.5518945,0 16,0.443864822 16,1 C16,1.55228475 15.5553691,2 14.9991283,2 L14.9991283,2 L12.0985466,2 L12.893423,6.03299751 C13.0008416,6.57801172 12.6750629,6.86935316 12.1461722,6.69715149 C12.1461722,6.69715149 10.5338343,6 8,6 C5.46616573,6 3.81930961,6.7027418 3.81930961,6.7027418 C3.30512699,6.87786645 2.97553288,6.58670099 3.08704936,6.03299751 L3.08704936,6.03299751 L3.89929946,2 L1.00087166,2 C0.448105505,2 0,1.55613518 0,1 C0,0.44771525 0.444630861,0 1.00087166,0 L1.00087166,0 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Graduation Cap',
    width: 16,
    height: 9,
};
var muiGradCap24 = {
    paths: [
        {
            path: 'M1,4 C1.55228475,4 2,4.44771525 2,5 L2,11 C2,11.5522847 1.55228475,12 1,12 C0.44771525,12 6.76353751e-17,11.5522847 0,11 L0,5 C-6.76353751e-17,4.44771525 0.44771525,4 1,4 Z M20.9975383,0 C21.5511826,0 22,0.443864822 22,1 C22,1.55228475 21.5605417,2 20.9975383,2 L17,2 L17.8672077,8.43989848 C17.9405469,8.98451619 17.5787585,9.26795889 17.0551526,9.08807017 C17.0551526,9.08807017 14.4779406,8 11,8 C7.52205935,8 4.94484737,9.08807017 4.94484737,9.08807017 C4.42302258,9.27471254 4.05955982,8.98372388 4.13279228,8.43989848 L5,2 L1.00246167,2 C0.448817378,2 0,1.55613518 0,1 C0,0.44771525 0.43945834,0 1.00246167,0 L20.9975383,0 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Graduation Cap',
    width: 22,
    height: 12,
};
var muiGradCap = {
    base: muiGradCap16,
    smIcon: muiGradCap16,
    lgIcon: muiGradCap24,
};
exports.muiGradCap = muiGradCap;
//# sourceMappingURL=gradCap.js.map